export default {
  name: 'marking--erpKmUpload',
  apiService: 'shoes',
  apiPath: '/admin/doc_erp_km/upload',
  urlParamName: 'marking--erpKmUpload',
};